import React, { useState } from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text4 } from "../../../styles";
import { handleApiExceptions, alertify } from '../../../app_methods';
import { Badge, Button, Descriptions, Input, Popconfirm, Popover } from "antd";
import { BATCH_STATUS_TYPES } from '../../../constants';


const ApprovalsDrawer = (props) => {
    const [isSaving, setIsSaving] = useState(false);
    const [isRejecting, setIsRejecting] = useState(false);
    const batch = props.batch;
    const approval = props.batch.approval
    const user = props.user.user || null
    const [rejectReason, setRejectReason] = useState('');
    const [isCancelling, setIsCancelling] = useState(false);

    const approvalAction = async (status) => {
        if (approval && status) {
            status == 'approve' ?
                setIsSaving(true)
                :
                status == 'cancel' ?
                    setIsCancelling(true)
                    :
                    setIsRejecting(true)
            let response = await batch.approve_batch({ 'approval_id': approval.id, 'status': status, 'reject_reason': rejectReason })
            if (!response.success) {
                status == 'approve' ?
                    setIsSaving(false)
                    :
                    status == 'cancel' ?
                        setIsCancelling(false)
                        :
                        setIsRejecting(false)
                handleApiExceptions(response);
                return;
            }
            props.fetchBulkUploads()
            alertify("Success", response.data.message, "success");
        }
        status == 'approve' ?
            setIsSaving(false)
            :
            status == 'cancel' ?
                setIsCancelling(false)
                :
                setIsRejecting(false)
    }

    const rejectReasonContent = (
        <div style={{height: 60}}>
            <Input id="reject_reason" onChange={(e) => setRejectReason(e.target.value)} autoComplete="off" maxLength={50}></Input>
            <Button type="primary" style={{ "margin-top": 3, "float": "right"}}  size="small" onClick={() => approvalAction('reject')}>Submit</Button>
        </div>
    );

    const renderButton = () => {
        return (
            <>
                {![3,4,5].includes(approval.status)?
                    (((user.role == 3 && !approval.approver) || user.role == 2 && !approval.checker) ?
                        (<Descriptions.Item label="Action">
                            <Button type="primary" size="small" onClick={() => approvalAction('approve')} disabled={(user.is_admin || isSaving) ? true : false}> Approve</Button>
                            <Popover content={rejectReasonContent} title="Rejection Reason" placement="bottomRight" trigger="click">
                                <Button className="ml-2" type="danger" size="small" disabled={isRejecting} >Reject</Button>
                            </Popover>
                        </Descriptions.Item>)
                        : null)
                    : null}
            </>
        )
    }

    return (
        <EaseDrawer
            title={false}
            width={400}
            visible={props.visible}
            onClose={() => { props.toggleApprovalsDrawer() }}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                <div>
                    <Text1 className="d-block" strong>Approvals</Text1>
                    {
                        approval ? <>
                            <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                                <Descriptions.Item label="Batch Status">
                                    {props.batch.status ?
                                        <Badge color={BATCH_STATUS_TYPES[props.batch.status].color} text={BATCH_STATUS_TYPES[props.batch.status].label} />
                                        : null}
                                </Descriptions.Item>
                                {
                                <Descriptions.Item label="Maker">
                                <div className="w-100 d-flex justify-content-between align-items-center">
                                <Text4>{approval.maker ? approval.maker.name : "---"}</Text4>
                                {/* <Descriptions.Item label="Maker">{approval.maker ? approval.maker.name : "---"}</Descriptions.Item> */}
                                {
                                    batch.status == "unapproved" && user.role == 1 ? 
                                    <Popconfirm title="Are you sure you want to cancel transfer request?" okText="Yes" cancelText="No" onConfirm={() => approvalAction('cancel')}>
                                    <Button size="small" type="danger"  loading={isCancelling}ghost>Cancel</Button>
                                    </Popconfirm>:null
                                }
                                
                                </div>
                                </Descriptions.Item>
                       
                                }
                                        
                                {![4,5].includes(approval.status)?
                                    <>
                                        <Descriptions.Item label="Checked By">{approval.checker ? approval.checker.name : "---"}</Descriptions.Item>
                                        <Descriptions.Item label="Approved By">{approval.approver ? approval.approver.name : " ---"}</Descriptions.Item>
                                    </>
                                    : null}
                                {approval.status == 4 && approval.status !=5?
                                    <>
                                        <Descriptions.Item label="Rejected By">{approval.rejector ? approval.rejector.name : " ---"}</Descriptions.Item>
                                        <Descriptions.Item label="Rejection Reason">{approval.reject_reason ? approval.reject_reason : " ---"}</Descriptions.Item>
                                    </>
                                    : null}
                                {renderButton()}
                            </Descriptions>
                        </> : null
                    }
                </div>
            </div>
        </EaseDrawer>
    )
};

export { ApprovalsDrawer };
